/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BasePartyViewModel } from './BasePartyViewModel';
import {
    BasePartyViewModelFromJSON,
    BasePartyViewModelFromJSONTyped,
    BasePartyViewModelToJSON,
} from './BasePartyViewModel';
import type { SchemeEmployerModel } from './SchemeEmployerModel';
import {
    SchemeEmployerModelFromJSON,
    SchemeEmployerModelFromJSONTyped,
    SchemeEmployerModelToJSON,
} from './SchemeEmployerModel';

/**
 * 
 * @export
 * @interface ClientDetailsViewModel
 */
export interface ClientDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof ClientDetailsViewModel
     */
    proposalId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClientDetailsViewModel
     */
    shouldClearInvalidProductSelections?: boolean;
    /**
     * 
     * @type {BasePartyViewModel}
     * @memberof ClientDetailsViewModel
     */
    party: BasePartyViewModel;
    /**
     * 
     * @type {SchemeEmployerModel}
     * @memberof ClientDetailsViewModel
     */
    schemeEmployer?: SchemeEmployerModel;
}

/**
 * Check if a given object implements the ClientDetailsViewModel interface.
 */
export function instanceOfClientDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "party" in value;

    return isInstance;
}

export function ClientDetailsViewModelFromJSON(json: any): ClientDetailsViewModel {
    return ClientDetailsViewModelFromJSONTyped(json, false);
}

export function ClientDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': !exists(json, 'ProposalId') ? undefined : json['ProposalId'],
        'shouldClearInvalidProductSelections': !exists(json, 'ShouldClearInvalidProductSelections') ? undefined : json['ShouldClearInvalidProductSelections'],
        'party': BasePartyViewModelFromJSON(json['Party']),
        'schemeEmployer': !exists(json, 'SchemeEmployer') ? undefined : SchemeEmployerModelFromJSON(json['SchemeEmployer']),
    };
}

export function ClientDetailsViewModelToJSON(value?: ClientDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'ShouldClearInvalidProductSelections': value.shouldClearInvalidProductSelections,
        'Party': BasePartyViewModelToJSON(value.party),
        'SchemeEmployer': SchemeEmployerModelToJSON(value.schemeEmployer),
    };
}

